import React from "react";
import Intro from "../../assets/img/about-us/intro.jpg";
import Mission from "./mission";
import Vision from "./vision";
import ChoosingUS from "./ChoosingUs";

const AboutUs = () => {
  return (
    <>
    <section
        className="bg-position-top-center bg-dark bg-repeat-0 pt-6 position-relative"
        style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(${Intro})`,
            backgroundSize: "1920px 735px",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            
        }}
      >
        <div className="container p-5 my-4">
          <div className="row pt-lg-4 pt-xl-5 justify-content-center">
            <div className="col-md-6 pt-3 pt-md-4 pt-lg-5 text-center">
              <h1 className="display-2 text-light pb-2 mb-4 me-md-n5 ">
                Redefining Car Buying and Selling
              </h1>
              <p className="fs-lg opacity-90 text-light">
              At <span className="font-semibold">XLR8</span>, we believe in redefining the way people buy and sell cars.
                Our platform is built on transparency, efficiency, and trust, ensuring that both buyers and sellers experience
                a seamless and rewarding transaction.
              </p>
            </div>
          </div>
        </div>
    
    </section>
    <Mission/>
    <Vision/>
    <ChoosingUS/>
    <div style={{ marginTop: "60px" }}>
        <p className="text-center text-lg text-dark">
     Join <span className="font-bold">XLR8</span> today and experience a smarter, more efficient way to buy and sell cars! 🚗✨
  </p>
</div>

    </>
  );
};

export default AboutUs;